module.exports = __webpack_public_path__ + "static/media/1@1920w.bfef85ae.jpg";